import { useEffect, useState } from "react";
import "./App.css";
import styled from "styled-components";
import Countdown from "react-countdown";
import {Button, CircularProgress, Snackbar, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Alert from "@material-ui/lab/Alert";

import * as anchor from "@project-serum/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  shortenAddress,
} from "./candy-machine";

const ConnectButton = styled(WalletDialogButton)``;

const CounterText = styled.span``; // add your styles here

const MintContainer = styled.div``; // add your styles here

const MintButton = styled(Button)``; // add your styles here

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<number>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT

  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [startDate, setStartDate] = useState(new Date(props.startDate));

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const {
        candyMachine,
        goLiveDate,
        itemsAvailable,
        itemsRemaining,
        itemsRedeemed,
      } = await getCandyMachineState(
          wallet as anchor.Wallet,
          props.candyMachineId,
          props.connection
      );

      setItemsAvailable(itemsAvailable);
      setItemsRemaining(itemsRemaining);
      setItemsRedeemed(itemsRedeemed);

      setIsSoldOut(itemsRemaining === 0);
      setStartDate(goLiveDate);
      setCandyMachine(candyMachine);
    })();
  };

  const onMint = async () => {
    try {
      setIsMinting(true);
      if (wallet && candyMachine?.program) {
        const mintTxId = await mintOneToken(
            candyMachine,
            props.config,
            wallet.publicKey,
            props.treasury
        );

        const status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            "singleGossip",
            false
        );

        if (!status?.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
      refreshCandyMachineState();
    }
  };

  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
  ]);

  const useStyles = makeStyles((theme) => ({
    root: {
      ...theme.typography.button
    },
    bold: {
      lineHeight: 0,
      fontWeight: 800,
      fontSize: 15,
      padding: 0,
      margin: "auto"
    },
    centerTable:{
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
      overflowX: "auto"
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();


  return (
      <div>

        <MintContainer>
          <>
            <header id="masthead" itemType="https://schema.org/WPHeader">
              <p className="main-title bhf-hidden" itemProp="headline"><a href="https://www.solpresidents.com"
                                                                          title="SolPresidents" rel="home">SolPresidents</a>
              </p>
              <div data-elementor-type="wp-post" data-elementor-id="568" className="elementor elementor-568"
                   data-elementor-settings="[]">
                <div className="elementor-section-wrap">
                  <section
                      className="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-b7a3210 elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                      data-id="b7a3210" data-element_type="section"
                      data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                          className="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e4382fc exad-glass-effect-no exad-sticky-section-no"
                          data-id="e4382fc" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <section
                              className="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-e9ee2f7 elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                              data-id="e9ee2f7" data-element_type="section">
                            <div className="elementor-container elementor-column-gap-no">
                              <div
                                  className="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-383f266 exad-glass-effect-no exad-sticky-section-no"
                                  data-id="383f266" data-element_type="column">
                                <div className="elementor-widget-wrap">
                                </div>
                              </div>
                              <div
                                  className="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5c82131 exad-glass-effect-no exad-sticky-section-no"
                                  data-id="5c82131" data-element_type="column">
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      className="elementor-element elementor-element-a237598 e-grid-align-right e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-social-icons"
                                      data-id="a237598" data-element_type="widget" data-widget_type="social-icons.default">
                                    <div className="elementor-widget-container">
                                      <div className="elementor-social-icons-wrapper elementor-grid">
							<span className="elementor-grid-item">
					<a className="elementor-icon elementor-social-icon elementor-social-icon-twitter elementor-animation-bob elementor-repeater-item-2cfd41a"
                       href="https://twitter.com/SolPresidents" target="_blank" rel="noreferrer">
						<span className="elementor-screen-only">Twitter</span>
						<i className="fab fa-twitter"/>					</a>
				</span>
                                        <span className="elementor-grid-item">
					<a className="elementor-icon elementor-social-icon elementor-social-icon-discord elementor-animation-bob elementor-repeater-item-1590241"
                       href="https://discord.com/invite/solpresidents" target="_blank" rel="noreferrer">
						<span className="elementor-screen-only">Discord</span>
						<i className="fab fa-discord"/>					</a>
				</span>
                                        <span className="elementor-grid-item">
					<a className="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-animation-bob elementor-repeater-item-4d82582"
                       href="https://www.instagram.com/solpresidents/" target="_blank" rel="noreferrer">
						<span className="elementor-screen-only">Instagram</span>
						<i className="fab fa-instagram"/>					</a>
				</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                      className="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-5fe22b0 elementor-section-content-middle she-header-yes elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                      data-id="5fe22b0" data-element_type="section"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;transparent&quot;:&quot;yes&quot;,&quot;transparent_on&quot;:[&quot;desktop&quot;],&quot;shrink_header&quot;:&quot;yes&quot;,&quot;shrink_header_logo&quot;:&quot;yes&quot;,&quot;scroll_distance&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:60,&quot;sizes&quot;:[]},&quot;scroll_distance_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;scroll_distance_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;custom_height_header&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:70,&quot;sizes&quot;:[]},&quot;custom_height_header_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;custom_height_header_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;custom_height_header_logo&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:70,&quot;sizes&quot;:[]},&quot;custom_height_header_logo_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;custom_height_header_logo_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}">
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                          className="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-88fc440 exad-glass-effect-no exad-sticky-section-no"
                          data-id="88fc440" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <section
                              className="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-5a52491 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                              data-id="5a52491" data-element_type="section">
                            <div className="elementor-container elementor-column-gap-no">
                              <div
                                  className="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e3d2b26 exad-glass-effect-no exad-sticky-section-no"
                                  data-id="e3d2b26" data-element_type="column">
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      className="elementor-element elementor-element-848aca7 exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-image"
                                      data-id="848aca7" data-element_type="widget" data-widget_type="image.default">
                                    <div className="elementor-widget-container">
                                      <a href="https://solpresidents.com/">
                                        <img width="608" height="410"
                                             src="https://www.solpresidents.com/wp-content/uploads/2021/10/Official_Logo_SolPresidents-removebg-preview.png"
                                             className="attachment-full size-full" alt="" loading="lazy"
                                             srcSet="https://www.solpresidents.com/wp-content/uploads/2021/10/Official_Logo_SolPresidents-removebg-preview.png 608w, https://www.solpresidents.com/wp-content/uploads/2021/10/Official_Logo_SolPresidents-removebg-preview-300x202.png 300w"
                                             sizes="(max-width: 608px) 100vw, 608px"/> </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                  className="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-54628c6 exad-glass-effect-no exad-sticky-section-no"
                                  data-id="54628c6" data-element_type="column">
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      className="elementor-element elementor-element-d6bc794 hfe-nav-menu__align-right hfe-submenu-icon-arrow hfe-submenu-animation-none hfe-link-redirect-child hfe-nav-menu__breakpoint-tablet exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-navigation-menu"
                                      data-id="d6bc794" data-element_type="widget"
                                      data-widget_type="navigation-menu.default">
                                    <div className="elementor-widget-container">
                                      <div
                                          className="hfe-nav-menu hfe-layout-horizontal hfe-nav-menu-layout horizontal hfe-pointer__none"
                                          data-layout="horizontal">
                                        <div className="hfe-nav-menu__toggle elementor-clickable">
                                          <div className="hfe-nav-menu-icon">
                                            <i aria-hidden="true" className="fas fa-align-justify"/></div>
                                        </div>
                                        <nav className="hfe-nav-menu__layout-horizontal hfe-nav-menu__submenu-arrow"
                                             data-toggle-icon="&lt;i aria-hidden=&quot;true&quot; tabindex=&quot;0&quot; class=&quot;fas fa-align-justify&quot;&gt;&lt;/i&gt;"
                                             data-close-icon="&lt;i aria-hidden=&quot;true&quot; tabindex=&quot;0&quot; class=&quot;far fa-window-close&quot;&gt;&lt;/i&gt;"
                                             data-full-width="yes">
                                          <ul id="menu-1-d6bc794" className="hfe-nav-menu">
                                            <li id="menu-item-562"
                                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/" className="hfe-menu-item">Home</a>
                                            </li>
                                            <li id="menu-item-566"
                                                className="menu-item menu-item-type-post_type menu-item-object-page parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/roadmap/"
                                                 className="hfe-menu-item">Roadmap</a></li>
                                            <li id="menu-item-567"
                                                className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-35 current_page_item parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/what-is-an-nft/"
                                                 className="hfe-menu-item">What is an NFT</a></li>
                                            <li id="menu-item-563"
                                                className="menu-item menu-item-type-post_type menu-item-object-page parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/faq-2/"
                                                 className="hfe-menu-item">FAQ</a></li>
                                            <li id="menu-item-565"
                                                className="menu-item menu-item-type-post_type menu-item-object-page parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/rarity-attributes/"
                                                 className="hfe-menu-item">Rarity Attributes</a></li>
                                            <li id="menu-item-564"
                                                className="menu-item menu-item-type-post_type menu-item-object-page parent hfe-creative-menu">
                                              <a href="https://www.solpresidents.com/our-team/" className="hfe-menu-item">Our
                                                Team</a></li>
                                          </ul>
                                        </nav>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {!wallet ? (
                                  <div
                                      className="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-2b82e3f exad-glass-effect-no exad-sticky-section-no"
                                      data-id="2b82e3f" data-element_type="column">
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                          className="elementor-element elementor-element-e9a1c68 elementor-align-center exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-button"
                                          data-id="e9a1c68" data-element_type="widget" data-widget_type="button.default">
                                        <div className="elementor-widget-container">
                                          <div className="elementor-button-wrapper">
                                            <a href="#"
                                               className="elementor-button-link elementor-button elementor-size-sm elementor-animation-bob"
                                               role="button">
						<span className="elementor-button-content-wrapper">
						<span className="elementor-button-text"><ConnectButton className={classes.bold} variant="text" size="small" color="inherit">
                    <Typography className={classes.bold}>Connect Wallet</Typography>
                  </ConnectButton></span>
		</span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              ) : (
                                  <>
                                    <div
                                        className="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-2b82e3f exad-glass-effect-no exad-sticky-section-no"
                                        data-id="2b82e3f" data-element_type="column">
                                      <div className="elementor-widget-wrap elementor-element-populated">
                                        <div
                                            className="elementor-element elementor-element-e9a1c68 elementor-align-center exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-button"
                                            data-id="e9a1c68" data-element_type="widget" data-widget_type="button.default">
                                          <div className="elementor-widget-container">
                                            <div className="elementor-button-wrapper">
                                              <a href="#"
                                                 className="elementor-button-link elementor-button elementor-size-sm elementor-animation-bob"
                                                 role="button">
						<span className="elementor-button-content-wrapper">
						<span className="elementor-button-text">{wallet && (<span className={classes.bold}>Connected {shortenAddress(wallet.publicKey.toBase58() || "")}</span>
                        )}</span>
		</span>
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </>

                              )}

                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </header>


            <div id="content" className="site-content">
              <div className="ast-container">
                <div data-elementor-type="wp-page" data-elementor-id="35" className="elementor elementor-35"
                     data-elementor-settings="[]">
                  <div className="elementor-section-wrap">
                    <section
                        className="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-c4f0a2d elementor-section-boxed elementor-section-height-default elementor-section-height-default exad-glass-effect-no exad-sticky-section-no"
                        data-id="c4f0a2d" data-element_type="section"
                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div className="elementor-background-overlay"/>
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                            className="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-922f65b exad-glass-effect-no exad-sticky-section-no"
                            data-id="922f65b" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                                className="elementor-element elementor-element-9b64b1f elementor-widget-divider--view-line exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-divider"
                                data-id="9b64b1f" data-element_type="widget" data-widget_type="divider.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-divider">
            <span className="elementor-divider-separator">
            </span>
                                </div>
                              </div>
                            </div>
                            <div
                                className="elementor-element elementor-element-6753d41 exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-text-editor"
                                data-id="6753d41" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <p>SolPresidents NFT is made up of 50 total traits each character. The traits of every
                                  SolPresidents are randomized upon minting, creating truly unique Art. We have no
                                  limits on how many you can mint, it will be on a first come first serve basis.
                                  Pre-Sale starts at 0.59 SOL for the first 500 and will be minted at 1 SOL after.</p>
                              </div>

                              <div>
                                {!wallet ? (<img src="https://i.postimg.cc/ZnkFdksR/image0.png" alt="mintbanner"></img>):(<div></div>)}
                              </div>





                              {wallet && (
                                  <div>
                                    <table className={classes.centerTable}>
                                      <tr>
                                        <td className={classes.centerTable}>Wallet</td>
                                        <td className={classes.centerTable}><p className={classes.bold}>{wallet.publicKey.toBase58()}</p></td>

                                      </tr>
                                      <tr>
                                        <td className={classes.centerTable}>Balance</td>
                                        <td className={classes.centerTable}><p className={classes.bold}>{(balance || 0).toLocaleString()} SOL</p></td>
                                      </tr>
                                      {/*<tr>
                                        <td className={classes.centerTable}>Available</td>
                                        <td className={classes.centerTable}><p className={classes.bold}>{itemsAvailable}</p></td>
                                      </tr>
                                      <tr>
                                        <td className={classes.centerTable}>Redeemed</td>
                                        <td className={classes.centerTable}><p className={classes.bold}>{itemsRedeemed}</p></td>
                                      </tr>
                                      <tr>
                                        <td className={classes.centerTable}>Remaining</td>
                                        <td className={classes.centerTable}><p className={classes.bold}>{itemsRemaining}</p></td>
                                      </tr>*/}
                                    </table>
                                  </div>

                              ) }

                            </div>
                            {wallet &&
                            <div
                                className="elementor-element elementor-element-e9a1c68  elementor-align-center exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-button"
                                data-id="e9a1c68" data-element_type="widget" data-widget_type="button.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-button-wrapper"><a href="#"
                                                                             className="elementor-button-link elementor-button elementor-size-sm elementor-animation-bob g-button"
                                                                             role="button"><span
                                    className="elementor-button-content-wrapper"><span
                                    className="elementor-button-text">

                                  <span>

                                  <MintButton
                                      disabled={isSoldOut || isMinting || !isActive}
                                      onClick={onMint}
                                      variant="text"
                                      size="small"
                                      className={classes.bold}
                                  >
                                    {isSoldOut ? (
                                        <Typography className={classes.bold}>Sold Out</Typography>
                                    ) : isActive ? (
                                        isMinting ? (
                                            <CircularProgress className={classes.bold} color="inherit" />
                                        ) : (
                                            <Typography className={classes.bold}>Mint</Typography>
                                        )
                                    ) : (
                                        <Typography className={classes.bold}>
                                          <Countdown
                                              date={startDate}
                                              onMount={({ completed }) => completed && setIsActive(true)}
                                              onComplete={() => setIsActive(true)}
                                              renderer={renderCounter}
                                          />

                                        </Typography>



                                    )}
                                  </MintButton>
                                    </span>




                                    </span></span></a>
                                </div>
                              </div>
                            </div>
                            }


                            <div
                                className="elementor-element elementor-element-d22eee5 exad-sticky-section-no exad-glass-effect-no elementor-widget elementor-widget-menu-anchor"
                                data-id="d22eee5" data-element_type="widget" data-widget_type="menu-anchor.default">
                              <div className="elementor-widget-container">
                                <div id="s44" className="elementor-menu-anchor"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>

          </>
        </MintContainer>

        <Snackbar
            open={alertState.open}
            autoHideDuration={6000}
            onClose={() => setAlertState({ ...alertState, open: false })}
        >
          <Alert
              onClose={() => setAlertState({ ...alertState, open: false })}
              severity={alertState.severity}
          >
            {alertState.message}
          </Alert>
        </Snackbar>


      </div>


  );
};

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
      <CounterText>
        {hours + (days || 0) * 24} hours, {minutes} minutes, {seconds} seconds
      </CounterText>
  );
};

export default Home;
